import { Market } from "@features/market/config/i18n-config";

const groupingFormatters = new Map<string, Intl.NumberFormat>();

function getGroupingFormatter(locale: string) {
  const cached = groupingFormatters.get(locale);
  if (cached) return cached;

  const formatter = new Intl.NumberFormat(locale, { useGrouping: true });
  groupingFormatters.set(locale, formatter);
  return formatter;
}

export default function localizeQuantity(quantity: number, market: Market) {
  return getGroupingFormatter(market.locale).format(quantity);
}
